import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import useSWR from 'swr';
import { axios } from "../apis/common";
var fallbackData = {
  successRate: 0.9963,
  totalTxs: 1024653,
  totalVolume: 27984252942.54,
  totalWallets: 230383
};

var getTxDataSummary = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.get("/referral/tx_data_summary");

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getTxDataSummary() {
    return _ref.apply(this, arguments);
  };
}();

export var useTxDataSummary = function useTxDataSummary() {
  var _useSWR = useSWR('useTxDataSummary', getTxDataSummary),
      data = _useSWR.data,
      error = _useSWR.error;

  if (error) {
    console.error(error);
    return fallbackData;
  }

  if (!data) return fallbackData;
  return data;
};